import {Modal, Button} from 'react-bootstrap'
import {IResourceCenter} from '../../../types/resourceCenter'
import {ResourceContentViewer} from './ResourceContentViewer'

interface ModalViewResourceProps {
  isOpen: boolean
  onClose: () => void
  resource: IResourceCenter
}

export const ModalViewResource: React.FC<ModalViewResourceProps> = ({isOpen, onClose, resource}) => {
  const isUrl = !!resource.url

  return (
    <Modal show={isOpen} onHide={onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          <i className="bi bi-eye" />
          {resource.name}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{minHeight: 400}}>
        <ResourceContentViewer resource={resource} height={500} />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        {isUrl && (
          <Button
            variant="primary"
            onClick={() => window.open(resource.url!, '_blank', 'noopener,noreferrer')}
          >
            <i className="bi bi-box-arrow-up-right me-2" />
            Open in New Tab
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}
